module.exports.isSmlDevice = function(width) {
	if ( $(window).innerWidth() < width ) {
		return true;
	}
}

module.exports.deviceOrientation = function() {
	if(window.innerHeight > window.innerWidth){
    return 'portrait';
	} else {
		return 'landscape';
	}
}

module.exports.isMobile = function() {
	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone|SymbianOS|RIM|BB|MeeGo|Opera Mini/i.test(navigator.userAgent) ) {
		return true;
	}
}

module.exports.init = function() {
	// Check for touch devices
	document.addEventListener('touchstart', function addtouchclass(){ // first time user touches the screen
    document.documentElement.classList.add('is-touch') // add "can-touch" class to document root using classList API
    document.removeEventListener('touchstart', addtouchclass, false) // de-register touchstart event
	}, false);
}


// WEBPACK FOOTER //
// ./scripts/util/device.js